module.exports = __webpack_public_path__ + "media/images/navigation/videos-2f2a9bb91a74cdb05c42211a4da8276b.gif";